var regularSearchHitTemplates = {};

regularSearchHitTemplates.product = function(product) {
    if(!product.language || product.language == 'DUTCH') {
        product.language = 'Nederlands';
    }

    var output = ' \
        <div class="col-xs-6 col-sm-4"> \
            <div class="book-row-3"> \
                <div \
                    class="book-cover-container book-hoverable text-right item-container" \
                    data-hook="book-cover-container" \
                    data-cart-stock="'+product.inStock+'" \
                    data-state="'+product.stateDescription+'" \
                    data-model="'+product.model+'" \
                    data-id="'+product.id+'" \
                    data-title="'+product.title+'" \
                    data-author="'+product.authorsDescription+'" \
                    data-itemtype="product" \
                    data-currentRetailPrice="'+product.prices.retail.inclVat+'" \
                    data-priceFor="'+product.prices.sell.inclVat+'" \
                    onclick=""\
                    > \
                    <div class="rounded-small book-image rounded-small"> \
                        <img loading="lazy" data-hook="book-image" src="' + cover_domain + product.urlCover + '"> \
                        <div class="book-hoverable-triangle"></div> \
                        <i class="glyphicon glyphicon-info-sign"></i> \
                        '+product.actionCategoryButton+' \
                    </div> \
                    <div class="book-hover-actions"> \
                        <button  data-hook="add-cart" class="bg-orange rounded-small book-hover-add">Toevoegen</button> \
                        <a href="' + product.urlFront + '" class="bg-mediumBlue rounded-small book-hover-details">Bekijk product</a> \
                    </div> \
                    <div class="book-pricecontainer"> \
                        <div class="book-oldprice"> \
                            <div class="price-name"> \
                                <span>Nieuwprijs</span> \
                            </div> \
                            ' + product.prices.retail.inclVatFormatted + ' \
                        </div> \
                        <div class="book-newprice"> \
                            <div class="price-name"> \
                                Onze prijs \
                            </div> \
                            ' + product.prices.sell.inclVatFormatted + ' \
                        </div> \
                    </div> \
                    <div class="book-info-extended"> \
                        <div class="row text-left"> \
                            <div class="col-xs-5"> \
                                Uitvoering: \
                            </div> \
                            <div class="col-xs-7 slanted"> \
                                ' + product.model + ' \
                            </div> \
                        </div> \
                        <div class="row text-left"> \
                            <div class="col-xs-5"> \
                                Taal: \
                            </div> \
                            <div class="col-xs-7 slanted"> \
                                ' + product.language + ' \
                            </div> \
                        </div> \
                        <div class="row text-left"> \
                            <div class="col-xs-5"> \
                                Staat: \
                            </div> \
                            <div class="col-xs-7 slanted"> \
                                ' + product.stateDescription + ' \
                            </div> \
                        </div> \
                    </div> \
                </div> \
                </div> \
                <div class="text-center book-info"> \
                <div class="book-author">' + product.authorsUrlFront + '</div> \
                ' + product.title + ' \
            </div> \
        </div> \
    ';

    return output;
}

regularSearchHitTemplates.category = function(category) {
    var output = ' \
        <li> \
        <a href="' + category.urlFront + '"> \
            <span>' + category.description + '</span><br> \
        </a> \
        </li> \
    ';

    return output;
}

regularSearchHitTemplates.author = function(author) {
    var output = ' \
        <li> \
        <a href="' + author.urlFront + '"> \
            <span>' + author.description + '</span><br> \
        </a> \
        </li> \
    ';

    return output;
}

regularSearchHitTemplates.publisher = function(publisher) {
    var output = ' \
        <li> \
        <a href="' + publisher.urlFront + '"> \
            <span>' + publisher.description + '</span><br> \
        </a> \
        </li> \
    ';

    return output;
}

// @todo template aanpassen aan goede design partial
var categoryHitTemplate = function(product) {
    var actionCategoryBtns = "";
    if (product.actionCategoryBtns) {
        $.each(product.actionCategoryBtns, function (idx, btn) {
            actionCategoryBtns += btn;
        });
    }

    var englishBtn = product.language.toLowerCase() == 'engels' ? '<div class="english-book english-book-button-category-page"></div>' : '';

    var output = ' \
        <div \
            class="category-detail-book item-container" \
            data-hook="book-cover-container" \
            data-cart-stock="'+product.inStock+'" \
            data-state="'+product.stateDescription+'" \
            data-model="'+product.model+'" \
            data-id="'+product.id+'" \
            data-title="'+product.title+'" \
            data-author="'+product.authorsDescription+'" \
            data-itemtype="product" \
            data-currentRetailPrice="'+product.prices.retail.inclVat+'" \
            data-priceFor="'+product.prices.sell.inclVat+'"\
            > \
            <div class="category-detail-cover rounded-small"> \
                <div class="category-detail-imagecontainer rounded-small"> \
                    <a href="' + product.urlFront + '"> \
                        <div class="category-detail-image-container"> \
                            <img loading="lazy" data-hook="book-image" class="rounded-small" src="' + cover_domain + product.urlCover + '"> \
                        </div> \
                    </a> \
                </div> \
                <div class="book-pricecontainer hidden-xs hidden-sm"> \
                    <div class="book-oldprice"> \
                        ' + product.prices.retail.inclVatFormatted + ' \
                    </div> \
                    <div class="book-newprice"> \
                        ' + product.prices.sell.inclVatFormatted + ' \
                    </div> \
                </div> \
                <button data-hook="add-cart" class="bg-orange shadow-soft hidden-xs hidden-sm rounded-small">Toevoegen</button> \
                <div class="visible-xs visible-sm"> \
                </div> \
            </div> \
            <div class="category-detail-short-container"> \
                <div class="category-detail-short"> \
                    <div class="action-category-buttons-container hidden-xs">\
                    '+actionCategoryBtns+' \
                    </div>\
                    '+ product.authorsUrlFront +' \
                    <a class="no-underline" href="' + product.urlFront + '"> \
                        <h4 class="title">' + englishBtn + product.title + '</h4> \
                    </a> \
                    <small>Uitvoering: ' + product.model + '</small> \
                    <small>Status: ' + product.stateDescription + '</small> \
                    <p> \
                        ' + product.description + ' \
                    </p> \
                    <div class="detail-fadeout"></div> \
                </div> \
                <div class="category-detail-bottom"> \
                    <a href="' + product.urlFront + '" class="category-detail-more rounded-small">Meer</a> \
                    <div class="visible-xs visible-sm text-left"> \
                        <div class="category-detail-pricecontainer"> \
                            <span>Adviesprijs</span> \
                            <span class="oldprice text-right">' + product.prices.retail.inclVatFormatted + ' </span> \
                            <strong class="category-detail-newpricename inline-middle">Onze prijs</strong> \
                            <span class="category-detail-newprice inline-middle text-right"><strong>' + product.prices.sell.inclVatFormatted + '</strong></span> \
                        </div> \
                    </div> \
                </div> \
            </div> \
            <button data-hook="add-cart" class="bg-orange add-cart shadow-soft visible-xs visible-sm rounded-small">Toevoegen</button> \
        </div>';

    return output;
}
var bestSoldHitTemplate = function(product) {
    var actionCategoryBtns = "";
    if (product.actionCategoryBtns) {
        $.each(product.actionCategoryBtns, function (idx, btn) {
            actionCategoryBtns += btn;
        });
    }

    var englishBtn = product.language.toLowerCase() == 'engels' ? '<div class="english-book english-book-button-category-page"></div>' : '';

    var output = ' \
    <div \
    class="category-detail-book item-container" \
    data-hook="book-cover-container" \
    data-cart-stock="'+product.inStock+'" \
    data-state="'+product.stateDescription+'" \
    data-model="'+product.model+'" \
    data-id="'+product.id+'" \
    data-title="'+product.title+'" \
    data-author="'+product.authorsDescription+'" \
    data-itemtype="product" \
    data-currentRetailPrice="'+product.prices.retail.inclVat+'" \
    data-priceFor="'+product.prices.sell.inclVat+'"\
    > \
    <div class="category-detail-cover rounded-small"> \
        <div class="category-detail-imagecontainer rounded-small"> \
            <a href="' + product.urlFront + '"> \
                <div class="category-detail-image-container"> \
                <div class="topsold-rank-number"> \
                    '+product.bestSoldNumber+' \
                </div> \
                    <img loading="lazy" data-hook="book-image" class="rounded-small" src="' + cover_domain + product.urlCover + '"> \
                </div> \
            </a> \
        </div> \
        <div class="book-pricecontainer hidden-xs hidden-sm"> \
            <div class="book-oldprice"> \
                ' + product.prices.retail.inclVatFormatted + ' \
            </div> \
            <div class="book-newprice"> \
                ' + product.prices.sell.inclVatFormatted + ' \
            </div> \
        </div> \
        <button data-hook="add-cart" class="bg-orange shadow-soft hidden-xs hidden-sm rounded-small">Toevoegen</button> \
        <div class="visible-xs visible-sm"> \
        </div> \
    </div> \
    <div class="category-detail-short-container"> \
        <div class="category-detail-short"> \
            <div class="action-category-buttons-container hidden-xs">\
                    '+actionCategoryBtns+' \
                    </div>\
            '+ product.authorsUrlFront +' \
            <a class="no-underline" href="' + product.urlFront + '"> \
                <h4 class="title">' + englishBtn + product.title + '</h4> \
            </a> \
            <small>Uitvoering: ' + product.model + '</small> \
            <small>Status: ' + product.stateDescription + '</small> \
            <p> \
                ' + product.description + ' \
            </p> \
            <div class="detail-fadeout"></div> \
        </div> \
        <div class="category-detail-bottom"> \
            <a href="' + product.urlFront + '" class="category-detail-more rounded-small">Meer</a> \
            <div class="visible-xs visible-sm text-left"> \
                <div class="category-detail-pricecontainer"> \
                    <span>Adviesprijs</span> \
                    <span class="oldprice text-right">' + product.prices.retail.inclVatFormatted + ' </span> \
                    <strong class="category-detail-newpricename inline-middle">Onze prijs</strong> \
                    <span class="category-detail-newprice inline-middle text-right"><strong>' + product.prices.sell.inclVatFormatted + '</strong></span> \
                </div> \
            </div> \
        </div> \
    </div> \
    <button data-hook="add-cart" class="bg-orange add-cart shadow-soft visible-xs visible-sm rounded-small">Toevoegen</button> \
</div>';

    return output;
}

var upsellHitTemplate = function(product) {
    var output = ' \
        <div class="col-sm-4 col-md-3 swiper-slide"> \
           <div class="book-row-4"> \
              <div \
                class="book-cover-container book-hoverable text-right item-container" \
                data-hook="book-cover-container" \
                data-cart-stock="'+product.inStock+'" \
                data-state="'+product.stateDescription+'" \
                data-model="'+product.model+'" \
                data-id="'+product.id+'" \
                data-title="'+product.title+'" \
                data-author="'+product.authorsDescription+'" \
                data-itemtype="product" \
                data-currentRetailPrice="'+product.prices.retail.inclVat+'" \
                data-priceFor="'+product.prices.sell.inclVat+'" \
                onclick="" \
                > \
                 <div class="rounded-small book-image rounded-small"> \
                    <img loading="lazy" data-hook="book-image" src="' + cover_domain + product.urlCover + '"> \
                    <div class="book-hoverable-triangle"></div> \
                    <i class="glyphicon glyphicon-info-sign"></i> \
                    '+product.actionCategoryButton+' \
                 </div> \
                 <div class="book-hover-actions"> \
                    <button class="bg-orange rounded-small book-hover-add" data-hook="add-cart">Toevoegen</button> \
                    <a  href="' + product.urlFront + '" class="bg-mediumBlue rounded-small book-hover-details">Bekijk product</a> \
                 </div> \
                 <div class="book-pricecontainer"> \
                    <div class="book-oldprice"> \
                       <div class="price-name"> \
                          <span>Nieuwprijs</span> \
                       </div> \
                       ' + product.prices.retail.inclVatFormatted + ' \
                    </div> \
                    <div class="book-newprice"> \
                       <div class="price-name"> \
                          Onze prijs \
                       </div> \
                       ' + product.prices.sell.inclVatFormatted + ' \
                    </div> \
                 </div> \
              </div> \
           </div> \
           <div class="text-center book-info"> \
              <div class="book-author">' + product.authorsUrlFront + '</div> \
              ' + product.title + '                          \
           </div> \
        </div>';

    return output;
}